export default __webpack_public_path__ + "static/media/Facebook_Logo.37819112.svg";